<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('eves')"
          :directory="[$t('eves'), $t('eve')]"
          :icon="'users'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="text-sm-right mb-primary mb-sm-0 mb-md-0">
          <div class="dropdown d-inline-block btn-dropdown">
            <button
              type="button"
              class="btn btn-success dropdown-toggle ml-0 mr-2"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {{ $t("actions") }}
            </button>
            <div class="dropdown-menu">
              <a
                class="dropdown-item d-flex align-items-center p-3"
                :href="urlGenerator(`crm/eve/import`)"
              >
                <app-icon
                  stroke-width="1"
                  :name="'download'"
                  width="16"
                  height="16"
                  class="mr-3"
                />
                {{ $t("import_people") }}
              </a>
              <a
                class="dropdown-item d-flex align-items-center p-3"
                href=""
                @click.prevent="openContactModal()"
              >
                <app-icon
                  stroke-width="1"
                  :name="'plus-circle'"
                  width="16"
                  height="16"
                  class="mr-3"
                />
                {{ $t("add_leads_group") }}
              </a>
              <a
                class="dropdown-item d-flex align-items-center p-3"
                :href="urlGenerator(`crm/contact/type/list`)"
              >
                <app-icon
                  stroke-width="1"
                  :name="'settings'"
                  width="16"
                  height="16"
                  class="mr-3"
                />
                {{ $t("manage_lead_group") }}
              </a>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openModal()"
          >
            {{ $t("add_eve") }}
          </button>
        </div>
      </div>
    </div>
    <app-table :id="tableId" :options="options" @action="getAction" />

    <app-eve-modal
      v-if="isEveModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @openOrgModal="openOrganizationModal"
      @close-modal="closeModal"
    />
    <app-contact-type-modal
      v-if="isContactModalActive"
      :table-id="contacttableId"
      @close-modal="closeContactModal"
    />
    <app-confirmation-modal
      v-if="confirmationModalActive"
      modal-id="eve-delete-modal"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />

    <app-organization-modal
      v-if="organizationModal"
      :table-id="'organization-modal'"
      @close-modal="closeOrgModal"
    />

    <app-eve-quick-view
      v-if="isQuickViewModalActive"
      dal-id="quickViewModal"
      :selected-url="selectedUrl"
      @openActivityModal="commonActivityModal"
      @viewAllDeal="openViewAllDeal"
      @viewAllFollower="openViewAllFollower"
      @editNote="editNote"
      @close-modal="closeQuickViewModal"
    />

    <app-common-activity-modal
      v-if="eveActivitiesModal"
      :activity="rowData"
      :selected-url="editedUrl"
      @close-modal="closeActivityModal"
    />

    <app-common-all-deals
      v-if="viewAllDeal"
      :id="eveId"
      :context-type="'eve'"
      :table-id="'details-view-modal'"
      @close-modal="closeViewAllModal"
    />
    <app-common-all-follower
      v-if="viewAllFollower"
      :follower-data="followerUrl"
      @close-modal="closedFollowerModal"
    />
    <app-common-note-modal
      v-if="isNoteModal"
      :note="noteRowData"
      @close-modal="closeNoteModal"
    />
  </div>
</template>
<script>
import CoreLibrary from "@core/helpers/CoreLibrary.js";
import { collection, urlGenerator } from "@app/Helpers/helpers";
import { mapGetters } from "vuex";
import { owner, contactType, organization, tag } from "@app/Mixins/Global/FilterMixins";
import { getCustomFileds } from "@app/Mixins/Global/CustomFieldMixin";
import { DeleteMixin } from "@app/Mixins/Global/DeleteMixin";
export default {
  name: "Eve",
  extends: CoreLibrary,
  mixins: [owner, contactType, organization, tag, getCustomFileds, DeleteMixin],
  data() {
    return {
      urlGenerator,
      isEveModalActive: false,
      isContactModalActive: false,
      tableId: "eve-modal",
      contacttableId: "contact-modal",
      confirmationModalActive: false,
      isQuickViewModalActive: false,
      organizationModal: false,
      eveActivitiesModal: false,
      editedUrl: "",
      viewAllDeal: false,
      viewAllFollower: false,
      isNoteModal: false,
      noteRowData: null,
      eveId: null,
      selectedUrl: "",
      activityData: {},
      followerUrl: "",
      commonColumn: [
        
		{
          title: this.$t("eve-picture"),
          type: "custom-html",
          key: "profile_picture",
          modifier: (value, row) => {
            return value
              ? `<span class="img-list"><img src="${value.path}"/><div class="img-list-up"><img src="${value.path}"/></div></span>`
              : "-";
          },
        },
		{
          title: this.$t("title"),
          type: "link",
          key: "name",
          modifier: (value, row) => {
            return `crm/eves/${row.id}/edit`;
          },
        },
		 {
          title: this.$t("lead_group"),
          type: "custom-html",
          key: "contact_type",
          modifier: (value, row) => {
            return value
              ? `<span class="badge badge-pill badge-${value.class ?? "secondary"}">${
                  value.name
                }</span>`
              : "-";
          },
        },
	    {
          title: this.$t("typex"),
          type: "custom-html",
          key: "contact_type",
          modifier: (value, row) => {
			  if(value.id == 3){
				return 'FN';
			} else if(value.id == 6){
				return 'A';
			} else if(value.id == 7){
				return 'WS';
			} else if(value.id == 8){
				return 'MS';
			} else if(value.id == 9){
				return 'J';
			} else if(value.id == 12){
				return 'AR';
			} else if(value.id == 13){
				return 'B';
			} else if(value.id == 14){
				return 'BR';
			} else if(value.id == 15){
				return 'BX';
			} else if(value.id == 16){
				return 'C';
			} else if(value.id == 17){
				return 'CD';
			} else if(value.id == 18){
				return 'F';
			} else if(value.id == 19){
				return 'FR';
			} else if(value.id == 20){
				return 'FRN';
			} else if(value.id == 21){
				return 'G';
			} else if(value.id == 22){
				return 'GL';
			} else if(value.id == 23){
				return 'HM';
			} else if(value.id == 24){
				return 'HW';
			} else if(value.id == 25){
				return 'HWR';
			} else if(value.id == 26){
				return 'J';
			} else if(value.id == 27){
				return 'JB';
			} else if(value.id == 28){
				return 'L';
			} else if(value.id == 29){
				return 'P';
			} else if(value.id == 30){
				return 'PB';
			} else if(value.id == 31){
				return 'S';
			} else if(value.id == 32){
				return 'SW';
			} else if(value.id == 33){
				return 'SM';
			} else if(value.id == 34){
				return 'TA';
			} else if(value.id == 35){
				return 'U';
			} else if(value.id == 36){
				return 'UF';
			} else if(value.id == 37){
				return 'UM';
			}
          },
        },
				
		{
          title: this.$t("id"),
          type: "custom-html",
          key: "id",
          modifier: (value, row) => {
			  var number = value;
			var xnumber = ('00000' + number).slice(-5);
            return `<span>${xnumber}</span>`;
          },
        },		
		{
          title: this.$t("years"),
          type: "text",
          key: "year_on",
        },
		{
          title: this.$t("condi"),
          type: "text",
          key: "cond",
        },
		
        
        
        
        
        {
          title: this.$t("deals"),
          type: "text",
          key: "closed_deals",
        },
        
        {
          title: this.$t("tags"),
          type: "component",
          key: "tags",
          isVisible: true,
          componentName: "tags-type-column",
        },
        {
          title: this.$t("action"),
          type: "action",
          key: "invoice",
          isVisible: true,
        },
      ],
      options: {
        name: this.$t("eve_table"),
        url: "crm/eves",
        showHeader: true,
        columns: [],
        filters: [
          {
            title: this.$t("created_date"),
            type: "range-picker",
            key: "date",
            option: ["today", "thisMonth", "last7Days", "thisYear"],
          },
          {
            title: this.$t("lead_group"),
            type: "checkbox",
            key: "contact_type",
            option: [],
          },
          {
            title: this.$t("tag"),
            type: "multi-select-filter",
            key: "tags",
            option: [],
          },
        ],
        showSearch: true,
        showFilter: true,
        paginationType: "pagination",
        responsive: false,
        rowLimit: 50,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
        actions: [
          {
            title: this.$t("quick_view"),
            icon: "zap",
            type: "modal",
            component: "app-eve-quick-view",
            modalId: "quickViewModal",
            url: "",
          },
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "modal",
            component: "app-eve-modal",
            modalId: "eve-modal",
            url: "",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "modal",
            component: "app-confirmation-modal",
            modalId: "eve-delete-modal",
            url: "",
          },
        ],
      },
    };
  },
  methods: {
	  
	getEveValue() {
      this.axiosGet("crm/eve-value").then((response) => {
        this.options.filters.push({
          title: this.$t("eve_value"),
          type: "range-filter",
          key: "eve-value",
          minTitle: this.$t("minimum_value"),
          maxTitle: this.$t("maximum_value"),
          maxRange: response.data.max_eve_value,
          minRange:
            response.data.min_eve_value < response.data.max_eve_value
              ? response.data.min_eve_value
              : 0,
        });
      });
    },
    getAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `crm/eves/${rowData.id}`;
        this.isEveModalActive = true;
      } else if (actionObj.title == this.$t("delete")) {
        this.deleteUrl = `crm/eves/${rowData.id}`;
        this.confirmationModalActive = true;
      } else if (actionObj.title == this.$t("quick_view")) {
        this.selectedUrl = `crm/eve/navigation-change/${rowData.id + 1}?parm=previous`;
        this.isQuickViewModalActive = true;
      }
    },
    openModal() {
      this.isEveModalActive = true;
    },
    openContactModal() {
      this.isContactModalActive = true;
    },
    closeContactModal() {
      this.isContactModalActive = false;
      this.selectedUrl = "";
      $("#contact-type-modal").modal("hide");
    },
    closeModal() {
      this.isEveModalActive = false;
      this.selectedUrl = "";
      $("#eve-modal").modal("hide");
    },
    closeQuickViewModal() {
      this.isQuickViewModalActive = false;
      this.selectedUrl = "";
      $("#quickViewModal").modal("hide");
    },
    commonActivityModal(activity) {
      this.editedUrl = `crm/activities/${activity.id}`;
      this.rowData = activity;
      this.eveActivitiesModal = true;
    },
    openViewAllDeal(eveId) {
      this.eveId = eveId;
      this.viewAllDeal = true;
    },
    openViewAllFollower(followerUrl) {
      this.followerUrl = followerUrl;
      this.viewAllFollower = true;
    },
    editNote(activity) {
      this.noteRowData = activity;
      this.isNoteModal = true;
    },
    closeNoteModal() {
      this.isNoteModal = false;
      $("#note-modal").modal("hide");
    },
    closeViewAllModal() {
      this.viewAllDeal = false;
      $("#details-view-modal").modal("hide");
    },
    closedFollowerModal() {
      this.viewAllFollower = false;
      $("#details-view-modal").modal("hide");
    },

    closeActivityModal() {
      this.eveActivitiesModal = false;
      $("#common-activity-modal").modal("hide");
    },
    openOrganizationModal() {
      this.organizationModal = true;
      setTimeout(() => {
        $("#eve-modal").css({
          //"backdrop-filter": "blur(4px)"
          opacity: "0.5",
        });
      });
    },
    closeOrgModal() {
      this.$store.dispatch("getOrganization");
      $("#organization-modal").modal("hide");
      this.organizationModal = false;
      $("#eve-modal").css({
        opacity: "1",
        //"backdrop-filter": "blur(0px)"
      });
    },
  },
  computed: {
    ...mapGetters({
      organizationList: "getOrganization",
    }),
  },
  mounted() {
    this.getCustomFiled("eve");
	  setTimeout(() => {
      // this.$store.dispatch("getOwner"),
      this.getEveValue();
    }, 1000);
  },
};
</script>
<style>
.link-list {
  white-space: nowrap !important;
  max-width: 180px;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
